// ── 피드백 미입력 미팅 모아보기 모달 ──────────────────────────────────────────
// - 피드백이 아직 입력되지 않은 과거 미팅 목록
// - 항목 클릭 시 해당 날짜로 이동 + 결과 입력 모달 오픈

import React from 'react';
import Modal from '../../../components/Modal';
import { PencilIcon } from '../../../components/meetingmap/Icons';
import { ticketLabel } from '../../../components/meetingmap/utils';
import {
  ghostActionStyle,
  pendingEmptyStyle, pendingItemStyle, pendingItemTopStyle,
  pendingItemDateStyle, pendingItemTimeStyle, pendingItemTicketStyle,
  pendingItemTmStyle, pendingItemBottomStyle, pendingItemCompanyStyle,
  pendingItemEntryBtnStyle,
} from '../../../components/meetingmap/styles';

export function PendingFeedbackModal({
  open,
  onClose,
  pendingLoading,
  pendingList,
  adminMode,
  onEntryClick,  // (item) => void — 날짜 이동 + 결과 입력 모달 오픈
}) {
  return (
    <Modal
      open={open}
      title="피드백 필요한 미팅"
      icon="💬"
      onClose={onClose}
      width="min(480px, 96vw)"
      mobileSheet
      mobileSheetDragClose
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button type="button" style={ghostActionStyle} onClick={onClose}>
            닫기
          </button>
        </div>
      )}
    >
      {/* 로딩 중 */}
      {pendingLoading && (
        <div style={{ textAlign: 'center', padding: 24, color: 'var(--text-muted)', fontSize: 13 }}>
          불러오는 중...
        </div>
      )}

      {/* 빈 목록 */}
      {!pendingLoading && pendingList.length === 0 && (
        <div style={pendingEmptyStyle}>
          <span style={{ fontSize: 32 }}>✅</span>
          <div>피드백이 필요한 미팅이 없습니다.</div>
        </div>
      )}

      {/* 목록 */}
      {!pendingLoading && pendingList.length > 0 && (
        <div style={{ display: 'grid', gap: 8 }}>
          {pendingList.map((item) => (
            <div key={item.id} style={pendingItemStyle}>
              <div style={pendingItemTopStyle}>
                <span style={pendingItemDateStyle}>{item.visit_date}</span>
                <span style={pendingItemTimeStyle}>{item.visit_time || '-'}</span>
                {/* ticketLabel: 상품명만 표시 (유효기간/장수 제거) */}
                <span style={pendingItemTicketStyle}>
                  {/* contract_items 배열로 상품명 배지 표시 */}
                  {ticketLabel(item.contract_items, item.ticket_type)}
                </span>
                {adminMode && item.tm_name && (
                  <span style={pendingItemTmStyle}>{item.tm_name}</span>
                )}
              </div>
              <div style={pendingItemBottomStyle}>
                <strong style={pendingItemCompanyStyle}>{item.company_name || '-'}</strong>
                <button
                  type="button"
                  style={pendingItemEntryBtnStyle}
                  onClick={() => onEntryClick(item)}
                >
                  <PencilIcon size={12} />
                  결과 입력
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
